import * as React from "react";
import { SingleNavMenuLinkButtonWithOptions as ISingleNavMenuLinkButtonWithOptions } from "../../../pages/identity/useNavMenu";
import { Button, Dropdown, Space, Tooltip } from "antd";
import { SingleNavMenuLinkButton } from "./singleNavMenuLinkButton";
import { FormOutlined } from "@ant-design/icons";

interface Props {
  link: ISingleNavMenuLinkButtonWithOptions;
  index: number;
}
export const SingleNavMenuLinkButtonWithOptions: React.FC<Props> = ({ link, index }) => {
  if (!link.options || link.options.length < 1) {
    console.error("SingleNavMenuLinkButtonWithOptions is being used without giving any options");
    return <SingleNavMenuLinkButton link={link as any} index={index} />;
  }

  if (link.options.length > 1) {
    return (
      <div className="px-4">
        <Dropdown.Button
          // TODO why is this needed
          className={`my-1 create-nav-dropdown-buttons ${link.className || ""}`}
          onClick={(e) => {
            link.onClick();
          }}
          htmlType={link.htmlType || "button"}
          danger={link.danger}
          loading={link.loading}
          // TODO also update this type to use from ant types
          type={link.type as any}
          disabled={link.disabled}
          menu={{
            items: link.options.map((opt) => ({
              key: opt.label,
              label: opt.label,
              onClick: (e) => {
                opt.onClick();
              },
              htmlType: opt.htmlType || "button",
              danger: opt.danger,
              loading: opt.loading,
              // TODO also update this type to use from ant types
              type: opt.type as any,
              disabled: opt.disabled,
            })),
          }}
        >
          {link.label}
        </Dropdown.Button>
      </div>
    );
  }

  const option = link.options[0];

  return (
    <Space.Compact className="my-1 px-4">
      <Button
        onClick={(e) => {
          if (link.htmlType === "submit") {
            e.preventDefault();
          }
          link.onClick();
        }}
        htmlType={link.htmlType || "button"}
        danger={link.danger}
        loading={link.loading}
        className={`${link.className || ""}`}
        // TODO also update this type to use from ant types
        type={link.type as any}
        disabled={link.disabled}
        block
      >
        {link.label}
      </Button>
      <Tooltip title={option.label}>
        <Button
          onClick={(e) => {
            option.onClick();
          }}
          htmlType={option.htmlType || "button"}
          className={`${option.className || ""}`}
          danger={option.danger}
          loading={option.loading}
          // TODO also update this type to use from ant types
          type={option.type as any}
          disabled={option.disabled}
          // TODO can customize icon too
          icon={<FormOutlined />}
        />
      </Tooltip>
    </Space.Compact>
  );
};
